// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bulma-prose{border-bottom:1px solid var(--backdrop-dark)}.bulma-prose h1{font-size:2rem;margin-bottom:1rem}.bulma-prose h1,.bulma-prose h2{color:#363636;font-weight:600;line-height:1.125}.bulma-prose h2{font-size:1.5rem;margin-bottom:.75rem}.bulma-prose p:not(last-child){margin-bottom:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
